import { ShopOrderView } from "src/api/generated/erp/db/types/tables/shopOrderView.ts";
import { OpenCustomerOrderButton } from "src/components/views/erp/utilComponents/OpenCustomerOrderButton.tsx";
import { OpenProjectActivityButton } from "src/components/views/erp/utilComponents/OpenProjectActivityButton.tsx";
import { OpenShopOrderButton } from "src/components/views/erp/utilComponents/OpenShopOrderButton.tsx";
import { AsyncMenuButton } from "../../../../common/contextMenu/AsyncMenuButton.tsx";
import i18n from "i18next";
import { faList } from "@fortawesome/pro-regular-svg-icons";
import { ShopOrderAggregatedSourcesDataGrid } from "./ShopOrderAggregatedSourcesDataGrid.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

interface OpenShopOrderSourceButtonProps {
	row: ShopOrderView;
}

export const OpenShopOrderSourceButton = ({ row }: OpenShopOrderSourceButtonProps) => {
	const { openDialog } = useGenericDialog();

	if (row.source === "CUSTOMER_ORDER_LINE" && row.customerOrderId != null) {
		return <OpenCustomerOrderButton customerOrderId={row.customerOrderId} />;
	}
	if (row.source === "PROJECT_ACTIVITY_MATERIAL" && row.sourceProjectActivityId != null) {
		return <OpenProjectActivityButton projectActivityId={row.sourceProjectActivityId} />;
	}
	if (row.source === "SHOP_ORDER_LINE" && row.sourceShopOrderId != null) {
		return (
			<OpenShopOrderButton
				label={i18n.t("open_parent_shop_order")}
				shopOrderId={row.sourceShopOrderId}
			/>
		);
	}
	if (row.source === "AGGREGATED") {
		return (
			<AsyncMenuButton
				label={i18n.t("sources")}
				icon={faList}
				onClick={async () => {
					openDialog({
						title: i18n.t("shop_order_sources"),
						size: "xl",
						agentContext: {
							key: defineAgentUiContextKey("erp.production.shopOrderAggregatedSources.dialog"),
							title: i18n.t("shop_order_sources"),
							pathSegments: [`${i18n.t("shop_order")} ${row.shopOrderId}`],
							data: { shopOrderId: row.shopOrderId },
						},
						content: <ShopOrderAggregatedSourcesDataGrid shopOrderId={row.shopOrderId} />,
					});
				}}
			/>
		);
	}
	return null;
};
